import "core-js/features/map";
import "core-js/features/set";
import React from "react";
import ReactDOM from "react-dom";
import bridge from "@vkontakte/vk-bridge";
import App from "./App";

bridge.subscribe(({ detail: { type, data } }) => {
  if (type === "VKWebAppUpdateConfig") {
    const schemeAttribute = document.createAttribute("scheme");
    schemeAttribute.value = data.scheme ? data.scheme : "client_light";
    document.body.attributes.setNamedItem(schemeAttribute);
  }
});

bridge.send("VKWebAppInit");

const urlParams = new URLSearchParams(window.location.href);

ReactDOM.render(
  <App
    appId={urlParams.get("vk_app_id")}
    groupId={urlParams.get("vk_group_id")}
    platform={/web|android|iphone/.exec(urlParams.get("vk_platform"))?.pop()}
  />,
  document.getElementById("root")
);
if (process.env.NODE_ENV === "development") {
  import("./eruda").then(({ default: eruda }) => {}); //runtime download
}

const prevet = () => {
  alert("prevet");
};

var scrollYChild = 0;

function postMessageRun(event) {
  const message = JSON.parse(event.data);

  if (message == "top"){
    window.scrollTo({top: 0})
  }
  if (message == "save"){
    scrollYChild = window.scrollY;
  }
  if (message == "back"){
    window.scrollTo({top: scrollYChild})
  }
}

window.addEventListener("message", postMessageRun);
